import type { Deposit } from '@/domain/types';

/**
 * tv-g7y7 (Anas, 1 Oct): did this call set the customer up with a deposit link?
 *
 * True when a deposit for `customerId` that was not in `idsAtOpen` (the
 * customer's deposits when the work modal opened) is a link: no in-person
 * `method` (card over the phone and cash carry one), and still live — pending,
 * or already paid if the client paid it before the Agent closed the call. A
 * resend counts (it mints a fresh pending deposit), and so does a pay-at-studio
 * hold (the slot is held and the server takes the lead out of the sequences). A
 * link sent before this call never counts.
 *
 * When it is true the lead waits on the link and the link's own expiry handles a
 * no-show, so the "How did it go?" sheet is skipped and closing never counts as
 * No answer.
 */
export function sentDepositLinkSince(
  deposits: Record<string, Deposit>,
  customerId: string,
  idsAtOpen: ReadonlySet<string>,
): boolean {
  return Object.values(deposits).some(
    (d) =>
      d.customerId === customerId &&
      !idsAtOpen.has(d.id) &&
      !d.method &&
      (d.status === 'pending' || d.status === 'paid'),
  );
}

/** The ids of a customer's deposits right now (the work modal snapshots this at open). */
export function customerDepositIds(deposits: Record<string, Deposit>, customerId: string): Set<string> {
  return new Set(Object.values(deposits).filter((d) => d.customerId === customerId).map((d) => d.id));
}
